"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.geometryToApi = exports.apiToGeometry = exports.apiToPosition = exports.dateToApi = exports.booleanToApi = exports.numberToApi = exports.stringToApi = exports.apiToStringEnum = exports.apiToString = exports.apiToBoolean = exports.apiToNumber = exports.emptyOrText = exports.apiToFloatNumber = exports.apiToDate = exports.undefinedIfNull = void 0;
const Date_1 = require("../Date");
const helpers_1 = require("../../helpers");
const useInnerCoordinates_1 = require("../../map/projection/useInnerCoordinates");
const convertStringToGeometry_1 = require("../../map/tech/convertStringToGeometry");
const undefinedIfNull = (value) => {
    if (value === null)
        return undefined;
    return value;
};
exports.undefinedIfNull = undefinedIfNull;
const apiToDate = (value) => {
    return value === null || value === undefined || value === '' ? null : new Date(value);
};
exports.apiToDate = apiToDate;
const apiToFloatNumber = (value) => {
    return value === null ? null : parseFloat(value);
};
exports.apiToFloatNumber = apiToFloatNumber;
const emptyOrText = (value) => {
    return value ?? "";
};
exports.emptyOrText = emptyOrText;
const apiToNumber = (value) => {
    return value || 0;
};
exports.apiToNumber = apiToNumber;
const apiToBoolean = (value) => {
    return !!value;
};
exports.apiToBoolean = apiToBoolean;
const apiToString = (value) => {
    return value ? value.trim() : "";
};
exports.apiToString = apiToString;
const apiToStringEnum = (value, options) => {
    return value && options.includes(value) ? value : null;
};
exports.apiToStringEnum = apiToStringEnum;
const stringToApi = (value) => {
    return value ?? "";
};
exports.stringToApi = stringToApi;
const numberToApi = (value) => {
    const parsed = value !== null ? Number(value) : null;
    if (parsed === null || isNaN(parsed)) {
        return "";
    }
    else {
        return parsed;
    }
};
exports.numberToApi = numberToApi;
const b = (0, exports.numberToApi)(123);
console.log(b);
const booleanToApi = (value) => {
    return value && value !== "false" ? 1 : 0;
    //return value ? true : false;
};
exports.booleanToApi = booleanToApi;
const dateToApi = (value) => {
    return (value && (0, Date_1.dateToString)(value)) ?? "";
};
exports.dateToApi = dateToApi;
const apiToPosition = (st_x, st_y) => {
    const x = (0, exports.apiToFloatNumber)(st_x); //oposit order
    const y = (0, exports.apiToFloatNumber)(st_y); ///oposit order
    return x && y ? (0, helpers_1.mapPositionToReadableJTSK)(Math.round(x * 10000) / 10000, Math.round(y * 10000) / 10000) : undefined;
};
exports.apiToPosition = apiToPosition;
const apiToGeometry = (value) => {
    return value ? (0, useInnerCoordinates_1.convertInnerLocationsToGPS)((0, convertStringToGeometry_1.convertStringToGeometry)(`[${value}]`)) : null;
};
exports.apiToGeometry = apiToGeometry;
const isLocationEmpty = (value) => {
    return !value || value.length === 0 || value[0].length === 0;
};
const geometryToApi = (value, type = 'polygon') => {
    const convertedPoints = value ? (0, useInnerCoordinates_1.convertGPSToInnerLocations)(value) : null;
    const response = !isLocationEmpty(convertedPoints) ? JSON.stringify(type === 'polygon' ? convertedPoints[0] : convertedPoints) : null;
    return (0, exports.stringToApi)(response);
};
exports.geometryToApi = geometryToApi;
